export default "__VITE_ASSET__BlqiMTwP__";